import React, {Component} from 'react';
import * as routes from '../../const/routes';
import Video from '../../components/Video';
import VideoPage from '../../components/VideoPage';
import CloseBtn from '../../components/CloseBtn';
import * as videos from '../../const/videos';
import {withUiContext} from '../../UiContext';

const video = videos.factory2Dev;

class Factory2Dev extends Component {
    onEnded = () => {
        const { ui } = this.props;

        ui.setDriverStatus(false);
        ui.setIntroStatus(false);
        this.props.history.push(routes.FACTORY2);
    }

    render() {
        return (
            <VideoPage title = 'РАЗРАБОТКА И ПРОЕКТИРОВАНИЕ'>
                <Video
                    closeLink = { routes.FACTORY2 }
                    video = { video }
                    onEnded = { this.onEnded }
                />

                <CloseBtn link = { routes.FACTORY2 } />
            </VideoPage>
        );
    }
}

export default withUiContext(Factory2Dev);
